import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Arrow } from '../../components/global/Arrow/Arrow';
import styles from './SharedPaginationArrowItem.scss';

function SharedPaginationArrowItem({ children, href, isLeft, onClick, dataTn }) {
    return (
        <a
            href={href}
            onClick={onClick}
            className={classnames(styles.arrowItem, { [styles.isLeft]: isLeft })}
            data-tn={dataTn}
        >
            {!isLeft && children}
            <span className={styles.arrow}>
                <Arrow isLeft={isLeft} />
            </span>
            {isLeft && children}
        </a>
    );
}

SharedPaginationArrowItem.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
    isLeft: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
};

SharedPaginationArrowItem.defaultProps = {
    isLeft: false,
};

export { SharedPaginationArrowItem };
